import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpportunityCardComponent, OpportunityCardData } from './opportunity-card/opportunity-card.component';
import { OPPORTUNITIES_DATA } from './resources-data';
import { UserService } from '@app/services/api/user/user.service';
import { analytics } from '@app/events/segment/analytics';

@Component({
  selector: 'app-take-action',
  standalone: true,
  imports: [CommonModule, OpportunityCardComponent],
  templateUrl: './take-action.component.html',
  styleUrl: './take-action.component.css'
})
export class TakeActionComponent implements OnInit {
  activeTab: string = 'all';
  opportunities: OpportunityCardData[] = OPPORTUNITIES_DATA;
  userSchoolName: string | null = null;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.fetchUserSchool();
  }

  fetchUserSchool(): void {
    this.userService.getMe().subscribe({
      next: (userProfile) => {
        if (userProfile?.backgroundInfo?.school_name) {
          this.userSchoolName = userProfile.backgroundInfo.school_name;
        }
      },
      error: (error) => {
        console.error('Error fetching user profile:', error);
      }
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    analytics.track('Plan Action Filter', { filter: tab });
  }

  get filteredOpportunities(): OpportunityCardData[] {
    let filtered = this.opportunities;

    // Filter by user's school: show opportunities that either don't have a campus field or match user's school
    if (this.userSchoolName) {
      filtered = filtered.filter(opp =>
        !opp.campus || opp.campus === this.userSchoolName
      );
    }

    // Filter by active status
    filtered = filtered.filter(opp => opp.status === 'active');

    // Filter by tab selection
    if (this.activeTab === 'all') {
      return filtered;
    }

    // Filter by label type
    return filtered.filter(opp => opp.labelType === this.activeTab);
  }
}
